module.exports = __webpack_public_path__ + "static/media/FACURRYCA_MENU-normal.25b3c4ce.png";